import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { useAtendimentosFiltrados } from '../core/useAtendimentosFiltrados'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { NotaProfissionalList } from '../core/_models'
import { notaAtendimentosColumns } from './columns/_columns'
import { useT } from '_metronic/i18n/Metronici18n'

export const NotaAtendimentosTable = () => {
  const { isLoading, isError, refetch } = useQueryResponse()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const atendimentos = useAtendimentosFiltrados()
  const { t } = useT()

  const columns = useMemo(() => notaAtendimentosColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={`Nenhum atendimento encontrado para “${filters.protocolo.trim()}”`}
      description='Revise o protocolo digitado.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum atendimento nesta nota'
      description='Os atendimentos do repasse aparecem aqui.'
    />
  )

  return (
    <CustomTable<NotaProfissionalList>
      id='kt_table_notas_atendimentos'
      ariaLabel='Atendimentos da nota'
      itemLabel={{ singular: 'atendimento', plural: 'atendimentos' }}
      data={atendimentos}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
